<span class="productMapper vetcorPrice">
   <section
      class="p-2"
      *ngIf="state$ | async as state">
      <div class="stepper-page">
         <div class="flex-column ml-2">
            <vc-practice-select
               urlBase="vetcor-pricing/hospital-pricing"
               [autoselect]="false"
               [onlySourcePractices]="true" />
         </div>
         <ng-container *ngIf="selectedPracticeSKey() && (!activeCycle() || activeCycle()?.batchStatus == 3)">
            <div class="priceChanges-header-b1"></div>
            <div class="priceChanges-header-b2"></div>
            <div class="priceChanges-header py-2">
               <div class="pc-left">
                  <button
                     mat-button
                     (click)="showNewCodeDialog.set(true)"
                     class="v-button v-button-md v-green">
                     <i class="fa fa-add"></i>
                     &nbsp;New Code
                  </button>
                  <h5>
                     Please request your price changes to existing codes below for review. If you are creating a new code, please click this button to
                     provide additional information. You will be notified once your request is reviewed.
                  </h5>
               </div>
               <div class="pc-right d-flex justify-content-center align-items-center mt-1">
                  <div class="ml-auto">
                     <!--
                     <button
                        mat-button
                        (click)="exportTablePDF()"
                        class="v-button v-button-md v-green mr-2 mb-2">
                        <i class="fa fa-file-pdf"></i>
                        &nbsp;Print PDF
                     </button>
                     -->
                  </div>
                  <div>
                     <h3>Hospital Pricing</h3>
                     <h6
                        *ngIf="!!pricingCaptain"
                        class="captain-subtitle">
                        {{ pricingCaptain()?.firstName }} {{ pricingCaptain()?.lastName }}
                        <span class="c-name">&nbsp;|&nbsp; Pricing Captain</span>
                     </h6>
                  </div>
               </div>
            </div>

            <div class="form-group custom-form-wizard">
               <div *ngIf="!loadingNewPractice; else loadingSpinner">
                  <vetcor-pricing-table
                     [isCaptain]="false"
                     [isRequestView]="false"
                     [isReadOnly]="isReadOnly()"
                     [prices]="hospitalPrices()"></vetcor-pricing-table>
               </div>
               <ng-template #loadingSpinner>
                  <vc-spinner></vc-spinner>
               </ng-template>
               <ng-template #noResults>
                  <p>No pricing data for practice.</p>
               </ng-template>
               <vetcor-pricing-new-code
                  #newCodeDlg
                  [practiceSKey]="selectedPracticeSKey()"
                  [(showDialog)]="showNewCodeDialog" />
            </div>
         </ng-container>

         <ng-container *ngIf="selectedPracticeSKey() && activeCycle() && activeCycle()?.batchStatus != 3">
            <div class="stepper-top-right-buttons">
               <a href="javascript:void(0);"
			      (click)="showCoverSheetModal()">
                  <i class="fa fa-file-text"></i>
                  &nbsp;SHOW COVER SHEET
               </a>

               <a
                  href="javascript:void(0);"
                  (click)="exportTablePDF()">
                  <i class="pi pi-download"></i>
                  &nbsp;DOWNLOAD PRICE LIST
               </a>

               <div *ngIf="stepper.selectedIndex === 0 && pendingRows().length <= 0 && !isReadOnly()">
                  <button
                     mat-button
                     (click)="skipToStep3(stepper)"
                     class="v-button v-button-md v-green approve-submit-button">
                     Approve All & Submit
                     <i class="fa fa-caret-right"></i>
                  </button>
               </div>

               <div *ngIf="stepper.selectedIndex === 0 && pendingRows().length > 0 && !isReadOnly()">
                  <button
                     mat-button
                     (click)="proceedToStep2(stepper)"
                     class="v-button v-button-md v-green approve-submit-button">
                     Submit for Review & Continue to Booking
                     <i class="fa fa-caret-right"></i>
                  </button>
               </div>
            </div>

            <mat-horizontal-stepper
               #stepper
               [linear]="true"
               class="custom-stepper"
               [ngClass]="{
                  onStep1: stepper.selectedIndex === 0,
                  onStep2: stepper.selectedIndex === 1,
                  onStep3: stepper.selectedIndex === 2
               }">
               <mat-step
                  [completed]="firstStepCompleted"
                  [ngStyle]="{ 'background-color': 0 === 0 ? 'lightblue' : '' }">
                  <ng-template matStepLabel>
                     <mat-icon><i class="fa fa-tasks"></i></mat-icon>
                     Step 1: Code Review
                  </ng-template>
                  <form #firstStepCompleted="ngForm">
                     <!-- Pasted the same code from above, to work in stepper -->
                     <div class="form-group custom-form-wizard">
                        <div *ngIf="!loadingNewPractice; else loadingSpinner">
                           <vetcor-pricing-table
                              [isCaptain]="false"
                              [isRequestView]="false"
                              [isReadOnly]="isReadOnly()"
                              [prices]="hospitalPrices()"></vetcor-pricing-table>
                        </div>
                        <ng-template #loadingSpinner>
                           <vc-spinner></vc-spinner>
                        </ng-template>
                        <ng-template #noResults>
                           <p>No pricing data for practice.</p>
                        </ng-template>
                        <vetcor-pricing-new-code
                           #newCodeDlg
                           [practiceSKey]="selectedPracticeSKey()"
                           [(showDialog)]="showNewCodeDialog" />
                     </div>

                     <div class="stepper-buttons">
                        <button
                           *ngIf="pendingRows().length <= 0 && !isReadOnly()"
                           mat-button
                           (click)="skipToStep3(stepper)"
                           class="v-button v-button-md v-green">
                           Approve All & Submit
                        </button>
                        <button
                           *ngIf="pendingRows().length > 0 && !isReadOnly()"
                           mat-button
                           (click)="proceedToStep2(stepper)"
                           class="v-button v-button-md v-green">
                           Submit for Review & Continue to Booking
                        </button>
                     </div>
                  </form>
               </mat-step>

               <mat-step [ngClass]="{ currentStepLocation: stepper.selectedIndex === 1 }">
                  <ng-template matStepLabel>
                     <mat-icon><i class="fa fa-calendar"></i></mat-icon>
                     &nbsp;Step 2: Schedule
                  </ng-template>
                  <form>
                     <div
                        class="form-group custom-form-wizard"
                        style="margin-top: 0px; padding-bottom: 0px">
                        <div
                           style="
                              margin-top: 10px;
                              margin-bottom: 20px;
                              font-size: 17px;
                              color: #ed5c21;
                              width: 100%;
                              text-align: center;
                              font-weight: 600;
                           ">
                           ** Please select a date in your practice's preferred range,
                           <span style="font-weight: 700">
                              {{ activeCycle()?.discussionAvailable | date : "EEEE, MMMM d"
                              }}{{ activeCycle()?.discussionAvailable | date : "d" | ordinal }} -
                              {{ activeCycle()?.discussionComplete | date : "EEEE, MMMM d"
                              }}{{ activeCycle()?.discussionComplete | date : "d" | ordinal }}
                           </span>
                           **
                        </div>

                        <!--<vc-calendly-scheduler
                           [calendlyEmail]="pricingCaptain()?.email"
                           [startDate]="activeCycle()?.discussionAvailable"
                           [endDate]="activeCycle()?.discussionComplete"></vc-calendly-scheduler>-->
                     </div>

                     <div
                        style="font-size: 17px; font-weight: 600; margin-top: -85px; text-align: center; opacity: 0"
                        id="scheduleText">
                        Click the "Schedule Event" button above to continue to Step 3
                     </div>
                     <div
                        class="stepper-buttons"
                        style="margin-top: 20px">
                        <button
                           mat-button
                           matStepperPrevious
                           class="btn btn-secondary me-1">
                           Back
                        </button>
                     </div>
                  </form>
               </mat-step>

               <mat-step [ngClass]="{ currentStepLocation: stepper.selectedIndex === 2 }">
                  <ng-template matStepLabel>
                     <mat-icon><i class="fa fa-check"></i></mat-icon>
                     &nbsp;Step 3: Finish
                  </ng-template>

                  <div
                     style="
                        text-align: center;
                        margin-top: 30px;
                        margin-bottom: 40px;
                        margin-left: 30px;
                        margin-right: 30px;
                        padding: 40px;
                        border-radius: 6px;
                        background: #f9f9f9;
                     ">
                     <div
                        *ngIf="!approveAllPrices"
                        style="text-align: left; margin-right: 60px; display: inline-block; vertical-align: top">
                        <span style="font-size: 17px; font-weight: 600">Your products / services are scheduled to be reviewed on:</span>

                        <div
                           style="margin-top: 5px; font-size: 17px; font-weight: 600"
                           [innerHTML]="calendlySummary"></div>
                        <div style="font-size: 13px; font-weight: 400; color: #ed5c21; line-height: 17px; margin-top: 5px">
                           A calendar invitation has been sent to your email address.
                           <br />
                           Web conferencing details to follow.
                        </div>

                        <div style="margin-top: 25px">
                           <span style="font-size: 17px">Pricing Captain:</span>
                           <div
                              class="calendlySch"
                              *ngIf="!!pricingCaptain()">
                              {{ pricingCaptain().firstName }} {{ pricingCaptain().lastName }}
                              <br />
                              {{ pricingCaptain().email }}
                           </div>
                        </div>
                     </div>

                     <div
                        *ngIf="!approveAllPrices"
                        style="text-align: left; display: inline-block; vertical-align: top">
                        <span style="font-size: 17px; font-weight: 600; color: #01a978">Products under review:</span>

                        <span *ngFor="let product of pendingRows()">
                           <div style="margin-top: 5px; margin-bottom: 15px; font-size: 17px; line-height: 22px">
                              <span style="font-weight: 600">
                                 {{ product.recordName }}
                                 <ng-container *ngIf="product.recordType == 'SF'">
                                    &nbsp;
                                    <span style="color: #ff9118; font-size: 14px; font-style: italic">(System Fee)</span>
                                 </ng-container>
                                 <ng-container *ngIf="product.recordType == 'PF'">
                                    &nbsp;
                                    <span style="color: #ff9118; font-size: 14px; font-style: italic">(Product Fee)</span>
                                 </ng-container>
                                 <ng-container *ngIf="product.recordType == 'MP'">
                                    &nbsp;
                                    <span style="color: #ff9118; font-size: 14px; font-style: italic">(Min Price)</span>
                                 </ng-container>
                              </span>
                              <br />
                              <span style="font-weight: 500; font-size: 14px; color: #8e8e8e">
                                 {{
                                    product.recordType == "PF"
                                       ? "Old Fee Price"
                                       : product.recordType == "SF"
                                       ? "Old Fee Price"
                                       : product.recordType == "MP"
                                       ? "Old Min Price"
                                       : "Old Price"
                                 }}:
                                 {{ product.currentPrice | currency : "USD" : "symbol" : "1.2-2" }}
                                 |
                                 {{
                                    product.recordType == "PF"
                                       ? "New Fee Price"
                                       : product.recordType == "SF"
                                       ? "New Fee Price"
                                       : product.recordType == "MP"
                                       ? "New Min Price"
                                       : "New Price"
                                 }}:
                                 {{ product.productNewPrice | currency : "USD" : "symbol" : "1.2-2" }}
                              </span>
                           </div>
                        </span>
                     </div>

                     <div *ngIf="approveAllPrices">
                        <span style="font-size: 17px; font-weight: 600">Your products / services are approved.</span>

                        <div style="margin-top: 25px">
                           <span style="font-size: 17px">Pricing Captain:</span>
                           <div
                              class="calendlySch"
                              *ngIf="!!pricingCaptain()">
                              {{ pricingCaptain().firstName }} {{ pricingCaptain().lastName }}
                              <br />
                              {{ pricingCaptain().email }}
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="stepper-buttons"></div>
               </mat-step>
            </mat-horizontal-stepper>

            <div class="step-header">
               <div class="step-header-inner">
                  <h3 *ngIf="stepper.selectedIndex === 0">Hospital Pricing</h3>
                  <h6
                     *ngIf="!!pricingCaptain && stepper.selectedIndex === 0"
                     class="captain-subtitle">
                     {{ pricingCaptain().firstName }} {{ pricingCaptain().lastName }}
                     <span class="c-name">&nbsp;|&nbsp; Pricing Captain</span>
                  </h6>

                  <h3 *ngIf="stepper.selectedIndex === 1">Schedule Pricing Discussion</h3>
                  <h6
                     *ngIf="stepper.selectedIndex === 1"
                     class="captain-subtitle">
                     Select a time below to schedule a discussion with your Pricing Captain.
                  </h6>

                  <h3 *ngIf="stepper.selectedIndex === 2">You are Finished!</h3>
                  <h6
                     *ngIf="stepper.selectedIndex === 2"
                     class="captain-subtitle">
                     Review your submitted products or services.
                  </h6>
               </div>
            </div>
         </ng-container>
      </div>

      <button
         id="sureModalButton"
         data-bs-toggle="modal"
         data-bs-target="#sure_asset"
         style="display: none"></button>

      <!-- Are You Sure Modal -->
      <div
         *ngIf="activeCycle()"
         class="modal custom-modal fade"
         id="sure_asset"
         role="dialog">
         <div
            class="modal-dialog modal-dialog-centered"
            style="min-width: 850px">
            <div class="modal-content">
               <div class="modal-body">
                  <div class="form-header">
                     <h5>Thanks for reviewing your pricing!</h5>
                     <p style="font-size: 15px; margin-bottom: 20px; margin-top: 20px">
                        You have requested no changes. Please confirm submission to queue these for PIMS writeback on
                        {{ activeCycle()?.discussionAvailable | date : "EEEE, MMMM d"
                        }}{{ activeCycle()?.discussionAvailable | date : "d" | ordinal }}.
                     </p>
                  </div>
                  <div
                     class="modal-btn confirm-action"
                     style="margin-top: 40px">
                     <div class="row">
                        <div
                           class="col-6"
                           style="text-align: start">
                           <a
                              href="javascript:void(0);"
                              style="border: 1px solid #cccccc; background-color: #cccccc"
                              data-bs-dismiss="modal"
                              class="btn btn-primary cancel-btn">
                              Cancel
                           </a>
                        </div>
                        <!-- Discussion available instead of scheduled for if no changes requested -->
                        <div
                           class="col-6"
                           style="padding-left: 0px; text-align: right">
                           <a
                              href="javascript:void(0);"
                              class="btn btn-primary continue-btn"
                              (click)="confirmStep3()"
                              data-bs-dismiss="modal">
                              Submit for PIMS writeback on {{ activeCycle()?.discussionAvailable | date : "EEEE, MMMM d"
                              }}{{ activeCycle()?.discussionAvailable | date : "d" | ordinal }}
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</span>
